import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function hasSimpleListField(fields: SchemaField[]): boolean {
  for (const field of fields) {
    if (field.hidden) continue
    if (field.type === 'list') {
      if (!field.fields || field.fields.length === 0) return true
      if (hasSimpleListField(field.fields)) return true
    }
    if ((field.type === 'group' || field.type === 'section') && field.fields) {
      if (hasSimpleListField(field.fields)) return true
    }
    if (field.type === 'tabs' && field.tabs) {
      for (const tab of field.tabs) {
        if (hasSimpleListField(tab.fields ?? [])) return true
      }
    }
  }

  return false
}
